module.exports = __webpack_public_path__ + "static/media/waitlist-member-3.90faf1b3.jpeg";